import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from '../../../actions.js';
import tracking from '../../../tracking/tracking.js';
import { propertyTypes, userIntentsReduced } from '../../../utils/userIntentConfig.js';
import { getPropertyType, getReducedUserIntent } from '../../../realEstateTypes.js';
import { toCommercializationType } from '../../../userIntents.js';
import { getRealEstateType, getUserIntent } from '../../../selectors/selectors.js';
import RadioButtons from "./RadioButtons/RadioButtons";
import Button from "../../Button/Button";
import HomeOwnerToggle from "../HomeOwnerToggle/HomeOwnerToggle";
import styles from "./NewNavigationHeader.less";
import WidgetFrame from '../../Utils/Widget/Frame/Frame.jsx';

export const VIEW_TYPE_NEW_DASHBOARD = 'NewDashboard';
export const VIEW_TYPE_OLD_DASHBOARD = 'OldDashboard';

export const NewNavigationHeader = (props) => {
  const [propertyTypeTracking, setPropertyTypeTracking] = useState(props.propertyType);
  const [userIntentTracking, setUserIntentTracking] = useState(props.userIntent);
  const [valuesChanged, setValuesChanged] = useState(false);

  useEffect(() => {
    setPropertyTypeTracking(props.propertyType);
    setUserIntentTracking(props.userIntent);
    setValuesChanged(false);
  }, [props.propertyType, props.userIntent]);

  const handlePropertyTypeChange = (event) => {
    const propertyType = event.target.value;
    setPropertyTypeTracking(propertyType);
    setValuesChanged(true);
  };

  const handleUserIntentChange = (event) => {
    const userIntent = event.target.value;
    setUserIntentTracking(userIntent);
    setValuesChanged(true);
  };

  const getReportingSuffix = () => {
    const suffix = (props.viewType === VIEW_TYPE_NEW_DASHBOARD || props.viewType === VIEW_TYPE_OLD_DASHBOARD) ? '_new' : '';
    return suffix;
  };

  const applySelections = () => {
    const label = `${propertyTypeTracking}_${userIntentTracking}`;
    const realEstateType = `${propertyTypeTracking}_${toCommercializationType(userIntentTracking)}`;

    props.selectRealEstateType(realEstateType);
    props.selectUserIntent(userIntentTracking);

    tracking.report(label.toLowerCase() + getReportingSuffix());

    props.saveLastUserIntentAndPropertyType(userIntentTracking, realEstateType);

    setValuesChanged(false);
  }

  const renderContent = () => {
    const { groupName, viewType } = props;

    return (
      <div data-qa="" data-view-type={viewType} className={`grid-item ${styles.NewNavigationHeader}`}>
        <form className={`grid gutter-m ${viewType !== VIEW_TYPE_OLD_DASHBOARD ? 'margin-top-m' : '' }`}>
          <div className={`grid-item ${viewType === VIEW_TYPE_OLD_DASHBOARD ? 'desk-automatic-width' : ''}`}>
            <div className={"grid grid-flex"}>
              <div className={`grid-item`}>
                <RadioButtons
                  oneLine={(viewType === VIEW_TYPE_NEW_DASHBOARD || viewType === VIEW_TYPE_OLD_DASHBOARD)}
                  label={"Zeige mir an"}
                  mobileLabel={(viewType === VIEW_TYPE_NEW_DASHBOARD || viewType === VIEW_TYPE_OLD_DASHBOARD) ? 'Zeige mir' : 'Zeige mir an'}
                  minGroupWidth={(viewType === VIEW_TYPE_NEW_DASHBOARD || viewType === VIEW_TYPE_OLD_DASHBOARD) ? '224px' : 'unset'}
                  labelClass={styles.radioLabel}
                  listOptions={userIntentsReduced}
                  value={userIntentTracking}
                  groupName={`userIntents_${groupName}`}
                  onChange={handleUserIntentChange} />
              </div>
              <div className={`grid-item ${styles.secondRadios}`}>
                <RadioButtons
                  oneLine={(viewType === VIEW_TYPE_NEW_DASHBOARD || viewType === VIEW_TYPE_OLD_DASHBOARD)}
                  label={"für"}
                  minGroupWidth={(viewType === VIEW_TYPE_NEW_DASHBOARD || viewType === VIEW_TYPE_OLD_DASHBOARD) ? '224px' : 'unset'}
                  labelClass={styles.radioLabel}
                  listOptions={propertyTypes}
                  value={propertyTypeTracking}
                  groupName={`propertyTypes_${groupName}`}
                  onChange={handlePropertyTypeChange} />
              </div>
            </div>
          </div>
          <HomeOwnerToggle reportingSuffix={getReportingSuffix()} groupName={groupName} additionalClasses={styles.homeOwnerToggle} />
          <div className={`grid-item one-whole`}>
            <Button
              text={'Auswahl bestätigen'}
              disabled={!valuesChanged}
              onClickHandler={applySelections}
              buttonClass="button"
              sizeClass={styles.submitButton}
              id="btn-confirm-selection"
            />
          </div>
        </form>
      </div>
    );
  }

  const renderOldDashboardWidget = () => {
    return (
      <WidgetFrame appearance="noPaddingFrame">
        <div className="grid">
          {renderContent()}
        </div>
      </WidgetFrame>
    );
  }

  const { viewType } = props;
  if (viewType === VIEW_TYPE_OLD_DASHBOARD) {
    return renderOldDashboardWidget();
  }

  return renderContent();
};

NewNavigationHeader.defaultProps = {
  groupName: '_new_navigation_header',
  viewType: 'navigation',
};

NewNavigationHeader.propTypes = {
  propertyType: PropTypes.string.isRequired,
  groupName: PropTypes.string,
  viewType: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  selectRealEstateType: (value) => dispatch(actions.selectRealEstateType(value)),
  selectUserIntent: (value) => dispatch(actions.selectUserIntent(value)),
  saveLastUserIntentAndPropertyType: (userIntent, realEstateType) => dispatch(actions.saveLastUserIntentAndPropertyType(userIntent, realEstateType))
});

const mapStateToProps = (state) => ({
  propertyType: getPropertyType(getRealEstateType(state)),
  userIntent: getReducedUserIntent(getUserIntent(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewNavigationHeader);
